/* QOWAA FIT — Recently Viewed
   localStorage key `qowaa_recently_viewed` : [{handle,title,price,image,url,viewedAt}]
   - Sur PDP / page pack : enregistre le produit courant (dédup par handle, FIFO, cap).
   - Sur toute page portant la section : rend les cards (exclut le produit courant).
   - Masqué si < 2 entrées à afficher. GA4 `recently_viewed_click` (si dataLayer présent). */
(function () {
  'use strict';
  var KEY = 'qowaa_recently_viewed';
  var CAP = 12; // borne de stockage ; l'affichage est limité par data-max

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, CAP))); } catch (e) {}
  }

  function record(item) {
    if (!item || !item.handle) return;
    var list = read().filter(function (p) { return p && p.handle !== item.handle; });
    item.viewedAt = Date.now();
    list.unshift(item);
    write(list);
  }

  function escAttr(s) { return String(s == null ? '' : s).replace(/"/g, '&quot;'); }
  function escHtml(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function fmtPrice(cents) { return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€'; }

  // Récupère prix + prix barré EN DIRECT (indépendant du cache localStorage)
  function enrichPrice(priceEl, p) {
    if (!priceEl || !p || !p.url) return;
    var endpoint = p.url.split('?')[0].split('#')[0] + '.js';
    fetch(endpoint, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (prod) {
        if (!prod) return;
        var price = prod.price;
        var cmp = prod.compare_at_price || prod.compare_at_price_max || prod.compare_at_price_min || 0;
        var now = '<span class="rv-card__now">' + escHtml(p.price || fmtPrice(price)) + '</span>';
        if (cmp && cmp > price) {
          var off = Math.round((cmp - price) / cmp * 100);
          priceEl.innerHTML = now +
            '<span class="rv-card__was">' + fmtPrice(cmp) + '</span>' +
            '<span class="rv-card__off">−' + off + '%</span>';
        } else {
          priceEl.innerHTML = now;
        }
      })
      .catch(function () {});
  }

  function track(handle) {
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({ event: 'recently_viewed_click', product_handle: handle });
    }
  }

  function render(root) {
    var wrap = root.querySelector('[data-rv-wrap]');
    var listEl = root.querySelector('[data-rv-list]');
    if (!wrap || !listEl) return;
    var current = root.getAttribute('data-rv-current') || '';
    var max = parseInt(root.getAttribute('data-max'), 10) || 6;

    var items = read().filter(function (p) {
      return p && p.handle && p.handle !== current && p.url;
    }).slice(0, max);

    if (items.length < 2) { wrap.hidden = true; return; }

    var frag = document.createDocumentFragment();
    items.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'rv-card';
      a.href = p.url;
      a.setAttribute('aria-label', p.title || 'Produit');
      var img = p.image
        ? '<img src="' + escAttr(p.image) + '" alt="" loading="lazy" width="600" height="750">'
        : '';
      var priceHtml = '<span class="rv-card__now">' + escHtml(p.price || '') + '</span>';
      if (p.compare) {
        priceHtml += '<span class="rv-card__was">' + escHtml(p.compare) + '</span>';
        if (p.discount) priceHtml += '<span class="rv-card__off">−' + escHtml(p.discount) + '%</span>';
      }
      a.innerHTML =
        '<div class="rv-card__media">' + img + '</div>' +
        '<h3 class="rv-card__title"></h3>' +
        '<span class="rv-card__price">' + priceHtml + '</span>';
      a.querySelector('.rv-card__title').textContent = p.title || '';
      enrichPrice(a.querySelector('.rv-card__price'), p);
      a.addEventListener('click', function () { track(p.handle); });
      frag.appendChild(a);
    });
    listEl.innerHTML = '';
    listEl.appendChild(frag);
    wrap.hidden = false;
  }

  function initRecently(root) {
    if (!root) return;
    var rec = root.querySelector('[data-rv-record]');
    if (rec) {
      try { record(JSON.parse(rec.textContent)); } catch (e) {}
    }
    render(root);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-qw-recently]'), initRecently);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-qw-recently]'); if (r) initRecently(r);
  });
})();
